import { attendeeFetchData } from "./index";

const ceInfoAPI = {
  fetch: (attendeeId) => attendeeFetchData(`/api/v2/attendees/${attendeeId}/ce-info`),
};

export default ceInfoAPI;
